import { ReactElement } from "react";
import { Anchor } from "@twilio-paste/core/anchor";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { constants } from "./definitions";
import {
  wiseOwlViewCopy,
  WiseOwlElementIds,
} from "@twiliointernal/e2-commons-shared-definitions";

const LegalDisclaimer = (): ReactElement => {
  return (
    <Box
      as="article"
      marginX="auto"
      paddingY="space30"
      element={WiseOwlElementIds.WISE_OWL_LEGAL_DISCLAIMER}
    >
      <Text as="summary" color="colorTextWeak" fontSize="fontSize20">
        {wiseOwlViewCopy.legalDisclaimer.body}
        <Anchor
          href={constants.TWILIO_PRIVACY_NOTICE}
          showExternal
          marginLeft="space20"
        >
          {wiseOwlViewCopy.legalDisclaimer.twilioPrivacyNotice}
        </Anchor>
      </Text>
    </Box>
  );
};

export default LegalDisclaimer;
